
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/topics",
      function () {
        return require("private-next-pages/learn/topics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/topics"])
      });
    }
  